import { baseApi } from "../baseApi";
import { type ResponseTake, type RequestTake } from "./types";

export const take = async (body: RequestTake) => {
  return await baseApi<ResponseTake, RequestTake>({
    url: "/api/event/take",
    method: "POST",
    body,
    skipNotifyUnhandledError: true,
  });
};
